import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'

export const TwIcon = tw(Icon)`
  mr-6
  flex-none
  text-action-default
  group-visited/file:text-interactive-l20
`

export const TwName = tw.div`
  text-12
  leading-4
  font-semibold
  text-action-default
  group-visited/file:text-interactive-l20
  whitespace-nowrap
`
